import http from "../http-common";

class EmployeeService {
  getAll(params = {}) {
    return http.get("/employees", { params });
  }

  get(id) {
    return http.get(`/employees/${id}`);
  }

  create(data) {
    return http.post("/employees", data);
  }

  update(id, data) {
    return http.put(`/employees/${id}`, data);
  }

  delete(id) {
    return http.delete(`/employees/${id}`);
  }
}

export default new EmployeeService();
